<div class="modal-dialog modal-dialog-centered detail-modal">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Update Vebdor Reconciliation Detail</h4>
            <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="card">
                <div class="card-body">
                    <form [formGroup]="modelVendorRecoForm">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="VendorAmount" class="form-label">Vendor Amount</label>
                                    <input type="number" formControlName="txtVendorAmount"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="VendorAmount" >
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="OtherAmountFS" class="form-label">Other Amount FS</label>
                                    <input type="number" formControlName="txtOtherAmountFS"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="OtherAmountFS" >
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="OtherAmountNoFS" class="form-label">Other Amount No FS</label>
                                    <input type="number" formControlName="txtOtherAmountNoFS"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="OtherAmountNoFS" >
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="VendorOtherTotal" class="form-label">Vendor Other Total</label>
                                    <input type="number" formControlName="txtVendorOtherTotal"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="VendorOtherTotal" >
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="txtWeight" class="form-label">Weight</label>
                                    <input type="number" formControlName="txtWeight"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="txtWeight" >
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="txtDeductAmount" class="form-label">Deduct Amount</label>
                                    <input type="number" formControlName="txtDeductAmount"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="txtDeductAmount" >
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div class="card-header bg-transparent border-bottom text-uppercase">Description</div> -->
                            <div class="col-md-4 mt-1">
                                <div class="mb-2">
                                    <label for="txtRemark" class="form-label">Remark</label>
                                    <input type="text" formControlName="txtRemark"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="txtRemark" >
                                </div>
                            </div>
                            <div class="col-md-4  mt-1">
                                <div class="mb-2">
                                    <label for="txtClaim" class="form-label">Claim</label>
                                    <input type="text" formControlName="txtClaim"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="txtClaim" >
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal"
                (click)="updateVendorRecoDetails()">Save</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="reset()">Cancel</button>
        </div>
    </div>
</div>